import { Helmet } from 'react-helmet-async'

export default function MetaTags({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage = 'https://assets.auxodev.dk/assets/a2f45633-eb66-4ac0-a380-9125c1343795/img-7698-min-scaled.jpg',
  canonicalUrl,
}) {
  const finalTitle = title || 'EK Biler v/Steen Svensson Ek | Autoværksted i Hejnsvig'
  const finalDesc =
    description ||
    'EK Biler i Hejnsvig – lokalt autoværksted på Mejerivej 12. Book tid online eller kontakt værkstedet på 22 18 73 30.'
  const finalOgTitle = ogTitle || finalTitle
  const finalOgDesc = ogDescription || finalDesc

  return (
    <Helmet>
      <html lang="da-DK" />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDesc} />
      <meta name="twitter:image" content={ogImage} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}
